// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Buhta_models__Protocol_v1_bs from "./generated/Protocol_v1_bs.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Json__Json_decode from "melange-json/Json_decode.js";

function decode(decoder, json) {
  return {
          data: Json__Json_decode.field("data", (function (param) {
                  return Json__Json_decode.list(decoder, param);
                }), json),
          pagination: Json__Json_decode.field("pagination", (function (param) {
                  return Atdgen_codec_decode.decode(Buhta_models__Protocol_v1_bs.read_pagination, param);
                }), json)
        };
}

const Grid_wrap = {
  decode: decode
};

const read_t = Atdgen_codec_decode.make(function (json) {
      const str = Js__Js_json.classify(json);
      if (typeof str === "number") {
        return "";
      }
      switch (str.TAG | 0) {
        case /* JSONString */0 :
            return str._0;
        case /* JSONNumber */1 :
            return str._0.toPrecision(0);
        default:
          return "";
      }
    });

const write_t = Atdgen_codec_encode.make(function (str_num) {
      return str_num;
    });

const StringNum = {
  read_t: read_t,
  write_t: write_t
};

const encode = Atdgen_codec_encode.encode;

const decode$1 = Atdgen_codec_decode.decode;

export {
  encode ,
  decode$1 as decode,
  Grid_wrap ,
  StringNum ,
}
/* read_t Not a pure module */
